import React from "react";
import { Pencil, Trash2, Copy, FileEdit, PlusCircle } from "lucide-react"; // ✅ added Copy
import "./TemplateCard.css";

const TemplateCard = ({ 
  name, 
  parameters, 
  type, 
  onDelete,   
  onEdit, 
  onCopy,
  emptyMessage = "No template available" ,
  onEditReport, 
  onAddProductKeyword,
  isAddProductKeyword = false,
  onClick,
}) => {
  if (!name && !parameters) {
    return (
      <div className="template-card empty-card">
        <p className="empty-message">{emptyMessage}</p>
      </div>
    );
  }



  return (
    <div className="template-card" onClick={onClick} style={{ cursor: onClick ? "pointer" : "default" }}>
      {/* Header */}
      <div className="template-header">
        <h3 className="template-title">{name}</h3>
        <span className={`template-badge ${type || 'default'}`}>
        {type}
      </span>

      </div>

      {/* Description */}
      <p className="template-subtitle">{parameters} parameter(s)</p>

      {/* Actions */}
      <div className="template-actions" onClick={(e) => e.stopPropagation()}>
        <button className="delete-btn" onClick={onDelete}>
          <Trash2 size={16} />
        </button>
        <div style={{ display: 'flex'}}>
         {/* {isAddProductKeyword && (
          <button  title="Add Product Keyword"className="btn-edit" onClick={onAddProductKeyword}>
            <PlusCircle size={16} />
          </button>
         )} */}
          {/* <button  title="Edit Report"className="btn-edit" onClick={onEditReport}>
            <FileEdit size={16} />
          </button> */}
        {/* <button  className="btn-edit" onClick={onEdit}>
          <Pencil size={16} />
        </button> */}
        <button className="btn-edit" onClick={onCopy}>
          <Copy size={16} />
        </button>
        </div>
      </div>
    </div>
  );
};

export default TemplateCard;
